import { useState, useEffect, useContext } from "react";
import { USER_DATA } from "../../utils/constants";
import RepositoriesScreen from "./TestCases.screen";
import { toast } from "react-toastify";
import { getProjectById, getSuitesByProject } from "../../api/projects";
import { useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ProjectsTypes } from "../../interfaces/ProjectsTypes";
import { UserContext } from "../../contexts/UserContext";

export default function TestCasesContainer() {
  const [loading, setLoading] = useState(true);
  const [currentProject, setCurrentProject] = useState<ProjectsTypes>(
    {} as ProjectsTypes
  );
  const [suites, setSuites] = useState([]);

  const { user } = useContext(UserContext);
  const { id } = useParams();

  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetchCurrentProject();
  }, []);

  const fetchCurrentProject = async () => {
    const user_uuid = JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid;

    getProjectById(user_uuid, String(id))
      .then((response: any) => {
        setCurrentProject(response);
        fetchSuites();
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        toast.error(
          "Ocorreu um problema ou projeto não ecnontrado para seu usuário"
        );
        navigate("/projects");
        return;
      });
  };

  const fetchSuites = async () => {
    setLoading(true);

    const user_uuid = JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid;

    getSuitesByProject(String(user_uuid), String(id)).then((response: any) => {
      setSuites(response);
    });
  };

  return (
    <RepositoriesScreen
      loading={loading}
      currentProject={currentProject}
      suites={suites}
      reload={fetchCurrentProject}
    />
  );
}
